import BaseClass from "../BaseClass.js";

export default class ActionButton extends BaseClass {

    constructor(element) {
        super(element);

        this.actionUrl = null;
        this.urlOn = null;
        this.urlOff = null;
        this.postData = null;
        this.iconOnClass = null;
        this.iconOffClass = null;
        this.$actionContentHolder = null;
        this.$actionIcon = null;
        this.buttonType = "button";
        this.buttonState = "on";
        this.showLoadingIndicator = false;
        this.loading = false;
        this.reloadElementID = null;
        this.$replaceElement = null;
        this.$removeContainer = null;
        this.confirm = null;
        this.updateable = null;
        this.updateButtonID = null;

        this.init();
    }


    init() {
        this.actionUrl = this.$element.attr('data-action-url');

        let urlOn = this.$element.attr('data-url-on');
        if (urlOn != undefined && urlOn.length > 0) {
            this.urlOn = urlOn;
        }
        let urlOff = this.$element.attr('data-url-off');
        if (urlOff != undefined && urlOff.length > 0) {
            this.urlOff = urlOff;
        }


        let iconOnClass = this.$element.attr('data-icon-on');
        if (iconOnClass != undefined && iconOnClass.length > 0) {
            this.iconOnClass = iconOnClass;
        }
        let iconOffClass = this.$element.attr('data-icon-off');
        if (iconOffClass != undefined && iconOffClass.length > 0) {
            this.iconOffClass = iconOffClass;
        }

        let buttonType = this.$element.attr('data-button-type');
        if (buttonType != undefined && buttonType.length > 0) {
            let buttonTypes = ['button', 'toggle', 'reloadtrigger'];

            if (buttonTypes.indexOf(buttonType) != -1) {
                this.buttonType = buttonType;
            } else {
                console.error("wrong button type " + buttonType);
            }
        }

        let buttonState = this.$element.attr('data-button-state');
        if (buttonState != undefined && buttonState.length > 0) {
            if (buttonState == "on" || buttonState == "off") {
                this.buttonState = buttonState;
            } else {
                console.error("wrong button state");
            }

        }

        let reloadElementID = this.$element.data('reload-element-id');
        if (reloadElementID != undefined) {
            let $reloadElement = $('#' + reloadElementID);
            if ($reloadElement.length == 1) {
                this.reloadElementID = reloadElementID;
            }
        }

        let replaceElementId = this.$element.data('replace-element');
        if (replaceElementId != undefined) {
            let $replaceElement = $('#' + replaceElementId);
            if ($replaceElement.length == 1) {
                this.$replaceElement = $replaceElement;
            }
        }

        let removeContainerID = this.$element.data('remove-container');
        if (removeContainerID != undefined) {
            let $removeContainer = $('#' + removeContainerID);
            if ($removeContainer.length == 1) {
                this.$removeContainer = $removeContainer;
            }
        }

        if (this.$element.attr('data-loading-indicator') == 1) {
            this.showLoadingIndicator = true;
        }

        let $actionContentHolder = this.$element.find('[data-type="action_content"]');
        if ($actionContentHolder != undefined) {
            this.$actionContentHolder = $actionContentHolder;
        }

        let $actionIcon = this.$element.find('[data-type="action_icon"]');
        if ($actionIcon != undefined) {
            this.$actionIcon = $actionIcon;
        }

        let confirm = this.$element.data('confirm');
        if (confirm != undefined && confirm.length > 0) {
            this.confirm = confirm;
        }

        let updateable = this.$element.attr('data-button-updateable');
        if (updateable != undefined && updateable == 1) {
            this.updateable = true;
        }

        let updateButtonID = this.$element.attr('data-update-button-id');
        if (updateButtonID != undefined) {
            let $updateButton = $('#' + updateButtonID);
            if ($updateButton.length == 1) {
                this.updateButtonID = updateButtonID;
            }
        }

        let mySelf = this;
        this.clickListener = function () {
            event.preventDefault();
            event.stopPropagation();
            if (mySelf.confirm != null) {
                mySelf.handleConfirm();
            } else {
                mySelf.handleAction();
            }

        };

        this.$element.on('click', this.clickListener);

        if (this.updateable) {
            if (this.buttonType == "toggle") {
                this.updateStateListener = function (event, data) {
                    if (mySelf.$element.attr('id') == data.elementId) {
                        mySelf.setButtonState(data.state);
                    }
                };

                $(document).on('actionbutton:updatestate', this.updateStateListener);
            }
        }
    }

    handleConfirm() {
        if (confirm(this.confirm)) {
            this.handleAction();
        } else {
            return;
        }
    }

    prepareToggle() {
        if (this.buttonType == "toggle") {
            if (this.buttonState == "off") {
                // wird aktiviert
                this.setButtonState(true);
            } else if (this.buttonState == "on") {
                // wird deaktiviert
                this.setButtonState(false);
            }
        }
    }

    rollBackToggle() {
        this.prepareToggle();
    }

    setButtonState(state) {
        if (state) {
            // wird aktiviert
            this.actionUrl = this.urlOn;
            this.buttonState = "on";
            this.$element.attr('data-button-state', 'on');

            if (this.$actionIcon != null) {
                this.$actionIcon.removeClass(this.iconOffClass);
                this.$actionIcon.addClass(this.iconOnClass);
            }

            this.$element.removeClass('off').addClass('on');
        } else if (!state) {
            // wird deaktiviert
            this.actionUrl = this.urlOff;
            this.buttonState = "off";
            this.$element.attr('data-button-state', 'off');

            if (this.$actionIcon != null) {
                this.$actionIcon.removeClass(this.iconOnClass);
                this.$actionIcon.addClass(this.iconOffClass);
            }

            this.$element.removeClass('on').addClass('off');
        }
    }

    handleAction() {
        if (this.loading) {
            return;
        }

        let postData = this.$element.attr('data-post-data');
        if (postData != undefined && postData.length > 0) {
            this.postData = postData;
        }

        let mySelf = this;

        this.loading = true;
        this.$element.prop("disabled", true);

        if (this.buttonType == "reloadtrigger") {

            $(document).trigger('content:reload', {
                id: mySelf.reloadElementID,
                url: mySelf.actionUrl,
                postData: mySelf.postData
            });

            this.loading = false;
            this.$element.prop("disabled", false);

            return;
        }

        if (this.showLoadingIndicator) {
            $(document).trigger('show:loading');
        }

        this.prepareToggle();

        let url = this.actionUrl;

        if (this.reloadElementID != null) {
            postData += "&containerID=" + this.reloadElementID;
        }

        if (this.updateButtonID != null) {
            postData += "&buttonID=" + this.updateButtonID;
        }


        let jqxhr = $.post(url, postData, function () {
        }, 'json')
            .done(function (data) {
                mySelf.handleAjaxResponse(data);

                if(   mySelf.$element == undefined){
                    // Button wurde durch eine Action entfernt.
                    return;
                }

                mySelf.$element.prop("disabled", false);
                mySelf.loading = false;
                if (mySelf.showLoadingIndicator) {
                    $(document).trigger('hide:loading');
                }
            })
            .fail(function (data) {
                mySelf.rollBackToggle();

                mySelf.$element.prop("disabled", false);
                mySelf.loading = false;
                if (mySelf.showLoadingIndicator) {
                    $(document).trigger('hide:loading');
                }
            });
    }

    handleAjaxResponse(responseData) {

        let mySelf = this;

        if (responseData.actions != undefined) {
            responseData.actions.forEach(function (action) {
                switch (action.actionType) {
                    case "updatebuttoncontent":

                        let content = "";
                        if (action.data != undefined) {
                            mySelf.setActionContent(action.data.content);
                        }
                        break;
                }
            });
            super.handleAjaxResponse(responseData);
        }
    }

    setActionContent(content) {
        if (this.$actionContentHolder != null && content != undefined) {
            if (content > 0 || content.length > 0) {
                this.$actionContentHolder.html(content);
            } else {
                this.$actionContentHolder.empty();
            }
            this.$actionContentHolder.removeClass('hidden');
        }
    }

    destroyListener() {
        this.$element.off('click', this.clickListener);

        if (this.updateable) {
            if (this.buttonType == "toggle") {
                $(document).off('actionbutton:updatestate', this.updateStateListener);
            }
        }
    }
}